import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const DropdownSelectControl = ({
  visible,
  loading,
  className,
  children,
  ...rest
}) => {
  return (
    <Button {...rest} block className={cn(styles.root, className)}>
      {children}
      <Icon
        type={loading ? 'loading' : 'down'}
        className={cn(styles.icon, { [styles.visible]: visible })}
      />
    </Button>
  );
};

export default DropdownSelectControl;
